<script>
import { ref, onMounted } from 'vue';
import axiosInstance from '@/axiosConfig';
import { serverUrl } from '@/serverUrl';
import Swal from 'sweetalert2';


export default {
    name: 'PhotoGallery',

    setup() {
        const fileInput = ref(null);
        const images = ref([]);

        const handleDrop = (event) => {
            event.preventDefault();
            const files = event.dataTransfer.files;
            handleFiles(files);
        };

        const openFileManager = () => {
            fileInput.value.click();
        };

        const handleFiles = (files) => {
            console.log(files);
            uploadFiles(files);
        };

        const onFileChange = (event) => {
            const files = event.target.files;
            handleFiles(files);
        };

        const uploadFiles = async (files) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('images', files[i]);
            }

            try {
                const response = await axiosInstance.post('/upload/images', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                console.log('File caricati con successo:', response.data);
                loadImages();
            } catch (error) {
                console.error('Errore nel caricamento dei file:', error);
                alert('Errore nel caricamento dei file');
            }
        };

        const loadImages = async () => {
            try {
                const response = await axiosInstance.get('/upload/images');
                images.value = response.data.images; // Assumi che response.data sia un array di URL delle immagini
            } catch (error) {
                console.error('Errore nel caricamento delle immagini:', error);
                alert('Errore nel caricamento delle immagini');
            }
        };

        const onDeleteImage = (id) => {
            Swal.fire({
                text: 'Sei sicuro di volerer eliminare questa foto dalla gallery?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sì, elimina!',
                cancelButtonText: 'Annulla'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await axiosInstance.delete(`/upload/images/${id}`);
                        // Rimuovi l'immagine dall'elenco
                        images.value = images.value.filter(image => image._id !== id);
                        Swal.fire(
                            'Eliminata!',
                            'L\'immagine è stata eliminata.',
                            'success'
                        );
                    } catch (error) {
                        console.error('Errore nell\'eliminazione dell\'immagine:', error);
                        Swal.fire(
                            'Errore!',
                            'Si è verificato un errore durante l\'eliminazione dell\'immagine.',
                            'error'
                        );
                    }
                }
            });
        };


        // Carica le immagini al montaggio del componente
        onMounted(loadImages);

        return {
            fileInput,
            images,
            handleDrop,
            openFileManager,
            onFileChange,
            onDeleteImage,
            serverUrl
        };
    }
};
</script>

<template src="./PhotoGallery.html" />

<style scoped></style>